import { render, staticRenderFns } from "./StartMenu.vue?vue&type=template&id=1d71436e&scoped=true&"
import script from "./StartMenu.vue?vue&type=script&lang=js&"
export * from "./StartMenu.vue?vue&type=script&lang=js&"
import style0 from "./StartMenu.vue?vue&type=style&index=0&id=1d71436e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d71436e",
  null
  
)

export default component.exports